module.exports = __webpack_public_path__ + "media/Video 125.41c20427.mp4";